/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rg_allow_duplicates = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allow duplicates`)
};

const es_rg_allow_duplicates = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permitir duplicados`)
};

const de_rg_allow_duplicates = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duplikate erlauben`)
};

const nl_rg_allow_duplicates = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duplicaten toestaan`)
};

const fr_rg_allow_duplicates = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autoriser les doublons`)
};

const it_rg_allow_duplicates = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consenti duplicati`)
};

const pt_br2_rg_allow_duplicates = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permitir duplicatas`)
};

const pt_rg_allow_duplicates = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permitir duplicados`)
};

const ja_rg_allow_duplicates = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重複を許可`)
};

const zh_rg_allow_duplicates = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`允许重复`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rg_allow_duplicates = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rg_allow_duplicates(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rg_allow_duplicates", locale)
	if (locale === "en") return en_rg_allow_duplicates(inputs)
	if (locale === "es") return es_rg_allow_duplicates(inputs)
	if (locale === "de") return de_rg_allow_duplicates(inputs)
	if (locale === "nl") return nl_rg_allow_duplicates(inputs)
	if (locale === "fr") return fr_rg_allow_duplicates(inputs)
	if (locale === "it") return it_rg_allow_duplicates(inputs)
	if (locale === "pt-BR") return pt_br2_rg_allow_duplicates(inputs)
	if (locale === "pt") return pt_rg_allow_duplicates(inputs)
	if (locale === "ja") return ja_rg_allow_duplicates(inputs)
	return zh_rg_allow_duplicates(inputs)
};